import React, { useContext, useEffect, useState } from "react";
import intl from "react-intl-universal";

import { Plot } from "../../../../script/plot";
import plotUtils from "../../../../script/utils/plotUtils";
import { Progress } from "../../../components/Progress";
import { DialogFooter } from "../../../containers/DialogFooter";
import { EntryContext } from "../../../contexts/EntryContext";
import { DialogBody } from "../../../containers/DialogBody";
import { Dialog } from "../../../containers/Dialog";
import { Spacer } from "../../../components/Spacer";
import { Button } from "../../../components/Button";
import { mdiClose, mdiDownload } from "@mdi/js";
import ixusUtils from "../../../../script/utils/ixusUtils";
import { Group } from "fabric";
import { entryCanvasId, setHiddenEntryCanvasSize } from "../../Entry";
import reportRest from "../../../../rest/reportRest";
import ixusRest from "../../../../rest/ixusRest";

const layerName = "plan";
const measurmentsLayerName = "measurmentsLayer";
const textFieldsLayerName = "textFieldsLayer";

export const ReportDialog = props => {
    const entryContext = useContext(EntryContext);
    const { entry } = entryContext;

    const { plans } = entry;
    const ixusSetting = entry.ixusSetting || {};
    const ixusAreas = ixusSetting.ixusAreas || [];

    const [plot, setPlot] = useState();
    const [isGenerating, setIsGenerating] = useState(false);

    useEffect(() => {
        setHiddenEntryCanvasSize(900, 900);
        const p = new Plot(entryCanvasId, entry.id);
        p.addLayer(layerName, 10);
        p.addLayer(measurmentsLayerName, 150);
        p.addLayer(textFieldsLayerName, 160);
        setPlot(p);
        return () => p.canvas.dispose();
    }, []);

    const {refreshAfterZoom, generatePngUrl, zoomToObject} = plotUtils;

    const generateReport = async () => {
        let closeDialog = false;

        try {
            setIsGenerating(true);
            const layer = plot.getLayer(layerName);
            const measurmentsLayer = plot.getLayer(measurmentsLayerName);
            const textFieldsLayer = plot.getLayer(textFieldsLayerName);

            let reportImage;
            try {
                layer.removeObjects();
                const downloadedImg = await ixusRest.getReportImage(entry.id);
                if(downloadedImg) {
                    const imageObj = await plot.addImage(layer, 0, 0, 0, 1, 1, downloadedImg);
                    zoomToObject(plot, imageObj, 0);
                    await refreshAfterZoom(plot);
                    reportImage = generatePngUrl(plot);
                }
            } catch {
                console.error("Could not create reportImage.");
            }

            const planKeysToImages = {};
            for(let i = 0; i < plans.length; i++) {
                layer.removeObjects();
                measurmentsLayer.removeObjects();
                textFieldsLayer.removeObjects();
                const plan = plans[i];
                await ixusUtils.drawPlanAndResult(plan, ixusAreas, plot, layer);
                ixusUtils.drawMeasurments(plan, plot, measurmentsLayer, ixusAreas);
                await ixusUtils.drawTextFields(plan, plot, textFieldsLayer, ixusAreas, plans, ixusSetting.siteType);
                layer.getObjects().forEach(o => o.set("stroke", null));
                const ixusObjects = layer.getObjects().filter(o => o.mxwellname === "ixusAreaBounds");
                const group = new Group([...ixusObjects, ...measurmentsLayer.getObjects(), ...textFieldsLayer.getObjects()]);
                zoomToObject(plot, group, 300);
                await refreshAfterZoom(plot);
                const picture = generatePngUrl(plot);
                planKeysToImages[plan.key] = picture;
            }

            const request = {reportImage, planKeysToImages};
            await reportRest.getIxusReport(request, entry);
            closeDialog = true;
        } finally {
            setIsGenerating(false);

            if(closeDialog) {
                props.onClose();
            }
        }
    };

    const loading = isGenerating;

    return (
        <Dialog
            width="500px"
            title={intl.get("entry.ixusReport.reportButton")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <div style={{minHeight: "300px"}}>
                    <Progress loading={loading}>
                    </Progress>
                </div>
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiClose}
                    disabled={loading}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
                <Spacer variant="vertical"/>
                <Button
                    svgIcon={mdiDownload}
                    disabled={loading}
                    onClick={() => generateReport()}
                    value={intl.get("common.download")} />
            </DialogFooter>
        </Dialog>
    );
};